// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","697":"news"}[chunkId] || chunkId) + "." + {"177":"55167643","464":"68853793","697":"7ccde6da","711":"4ad3360c"}[chunkId] + ".css";
};